import { Injectable } from '@angular/core';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {Globals} from '../../global/globals';
import {Observable} from 'rxjs';
import {PatternPageDto} from '../../dtos/text/pattern-page-dto';
import {TextPatternCreationDto} from '../../dtos/text/text-pattern-dto';

@Injectable({
  providedIn: 'root'
})
export class TextPatternService {

  private textPatternBaseUri: string = this.globals.backendUri + '/text/patterns';
  private textPatternExportBaseUri: string = this.globals.backendUri + '/exports/text/patterns';

  constructor(private httpClient: HttpClient, private globals: Globals) { }

  searchTextPatterns(params: HttpParams): Observable<PatternPageDto> {
    return this.httpClient.get<PatternPageDto>(this.textPatternBaseUri, {params});
  }

  createTextPattern(pattern: TextPatternCreationDto): Observable<TextPatternCreationDto> {
    return this.httpClient.post<TextPatternCreationDto>(this.textPatternBaseUri, pattern);
  }

  getPattern(id: number): Observable<TextPatternCreationDto> {
    return this.httpClient.get<TextPatternCreationDto>(this.textPatternBaseUri + '/' + id);
  }

  updatePattern(id: number, pattern: TextPatternCreationDto): Observable<TextPatternCreationDto> {
    return this.httpClient.put<TextPatternCreationDto>(this.textPatternBaseUri + '/' + id, pattern);
  }

  deletePattern(id: number): Observable<void> {
    return this.httpClient.delete<void>(this.textPatternBaseUri + '/' + id);
  }

  exportAll(): Observable<HttpResponse<Blob>> {
    return this.httpClient.get(this.textPatternExportBaseUri, {observe: 'response', responseType: 'blob'});
  }
}
